import React from 'react';

type ReturnProps = {
    register: any;
    formState: FormStateType;
    handleSubmit: (args0: any) => void;
    resetForm: any;
};

type FormStateType = {
    isDirty: boolean;
    isSubmitted: boolean;
    touchedFields: object; //to be changed later
    defaultValues: any; //to be changed later
    // isValid: boolean;
    // isValidating: boolean;
    // error: { [key: string]: string };
};

export const useCustomForm = (props: any): ReturnProps => {
    const [formData, setFormData] = React.useState<any>(props?.defaultValues);
    const [isDirty, setIsDirty] = React.useState(false);
    const [isSubmitted, setIsSubmitted] = React.useState(false);
    const [touchedFields, setTouchedFields] = React.useState({});

    const handleSubmit = (formSubmit: any) => (): void => {
        formSubmit(formData);
        setIsSubmitted(true);
    };

    const handleChange =
        (key: string): any =>
        (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>): void => {
            setFormData((prev: any) => ({
                ...prev,
                [key]: e?.target?.value,
            }));
        };

    const resetForm = (optionalData?: any): void => {
        if (optionalData) {
            setFormData(optionalData);
            return;
        }
        setFormData(props?.defaultValues);
    };

    const register = (key: string): any => ({
        onChange: handleChange(key),
    });

    React.useEffect(() => {
        const formDataClone = JSON.parse(JSON.stringify(formData));
        if (Object.values(formData)?.some((item: any) => item?.length > 0)) {
            setIsDirty(true);
        } else {
            setIsDirty(false);
        }

        for (const key in formDataClone) {
            if (formDataClone[key]?.length === 0) {
                delete formDataClone[key];
                setTouchedFields(formDataClone);
            }
        }
    }, [formData]);

    return {
        register,
        handleSubmit,
        formState: {
            isDirty: isDirty,
            isSubmitted: isSubmitted,
            defaultValues: props?.defaultValues,
            touchedFields: touchedFields,
        },
        resetForm,
    };
};
